// Shared site chrome: top nav + mode toggle, used by every page.
// Link targets are resolved relative to the current page's directory so the
// same nav works from the root (index.html, about.html) and from /projects/.

const NAV_LINKS = [
  { target: 'about.html',          label: 'About' },
  { target: 'projects/index.html', label: 'Projects' }
];

// Pages under /projects/ live one directory deep; everything else is at root.
function pathPrefix() {
  return /\/projects\//.test(window.location.pathname) ? '../' : '';
}

// The landing page is the root index only — NOT /projects/index.html.
function isLanding() {
  const path = window.location.pathname;
  if (/\/projects\//.test(path)) return false;
  return path === '/' || path.endsWith('/index.html') || path.endsWith('index.html');
}

export function renderNav(container = document.body) {
  const prefix = pathPrefix();
  const home = isLanding() ? '#top' : `${prefix}index.html`;
  const contact = isLanding() ? '#contact' : `${prefix}index.html#contact`;

  const nav = document.createElement('nav');
  nav.className = 'nav';
  nav.id = 'nav';
  nav.innerHTML = `
    <a href="${home}" class="nav-brand">
      <span class="nav-brand-mark">H.</span>
      <span class="nav-brand-name">SHAOLIANG</span>
    </a>
    <ul class="nav-links">
      ${NAV_LINKS.map(l => `<li><a href="${prefix}${l.target}">${l.label}</a></li>`).join('')}
      <li>
        <button class="mode-toggle" id="modeToggle" aria-label="Toggle night mode" type="button">
          <span class="mode-toggle-dot"></span>
          <span class="mode-toggle-label" id="modeToggleLabel">NIGHT</span>
        </button>
      </li>
      <li><a href="${contact}" class="nav-cta">Contact &rarr;</a></li>
    </ul>
  `;
  container.prepend(nav);
}

function applyMode(mode) {
  document.documentElement.setAttribute('data-mode', mode);
  const label = document.getElementById('modeToggleLabel');
  if (label) label.textContent = mode === 'night' ? 'DAY' : 'NIGHT';
  try { localStorage.setItem('sl_mode', mode); } catch (_) {}
}

export function initNavigation() {
  let saved = 'day';
  try { saved = localStorage.getItem('sl_mode') || 'day'; } catch (_) {}
  applyMode(saved);

  const modeBtn = document.getElementById('modeToggle');
  if (modeBtn) {
    modeBtn.addEventListener('click', () => {
      const cur = document.documentElement.getAttribute('data-mode') || 'day';
      applyMode(cur === 'night' ? 'day' : 'night');
    });
  }
}
